export function getWindowLocalStorage(): Storage | undefined {
  return typeof window !== 'undefined' ? window.localStorage : undefined;
}
